import { takeLatest, put, call } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import * as campaignLiveStatusActions from "../actions/campaign-live-status.actions";
import * as campaignLiveStatusTypes from "../types/campaign-live-status.types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getCampaignLiveStatus(action) {
  try {
    const res = yield call(api.get, `/api/admin/campaign/live-status`, action.payload);
    if (res.status === 200) {
      yield put(campaignLiveStatusActions.getCampaignLiveStatusSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(campaignLiveStatusActions.getCampaignLiveStatusError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(campaignLiveStatusActions.getCampaignLiveStatusError(e));
  }
}



export default function* campaignDetailsSaga() {
  yield takeLatest(campaignLiveStatusTypes.getCampaignLiveStatus.GET_CAMPAIGN_LIVE_STATUS_REQUEST, getCampaignLiveStatus);
}
